import script from "./advantages-info.vue?vue&type=script&setup=true&lang=js"
export * from "./advantages-info.vue?vue&type=script&setup=true&lang=js"

import "./advantages-info.vue?vue&type=style&index=0&id=40cc216c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40cc216c"]])

export default __exports__